import Vue from "vue";

import VuetifyMask from "vuetify-mask";
import MediaList from 'Components/common/MediaList'
import VDateField from 'Components/common/inputmask/VDateField'
import VHourMinuteField from 'Components/common/inputmask/VHourMinuteField'
import UserSelector from 'Components/common/UserSelector'
import VOfferRowField from 'Components/common/VOfferRowField'
import VOfferRow from 'Components/common/VOfferRow'
import SearchField from 'Components/common/SearchField'
import DatetimePicker from 'vuetify-datetime-picker'

Vue.use(VuetifyMask);
Vue.use(DatetimePicker);

Vue.component('v-date-field', VDateField);
Vue.component('v-hour-minute-field', VHourMinuteField);
Vue.component('v-media-list', MediaList);
Vue.component('user-selector', UserSelector);
Vue.component('v-offer-row-field', VOfferRowField);
Vue.component('v-offer-row', VOfferRow);
Vue.component('search-field', SearchField);
